// ===================== TYPES =====================

export type ApplicationStatus =
  | 'Yeni Başvuru'
  | 'Öğretmen Aranıyor'
  | 'Öğretmene Yönlendirildi'
  | 'Deneme Dersi Planlandı'
  | 'Deneme Dersi Yapıldı'
  | 'Aktif Derse Başladı'
  | 'Takipte'
  | 'Devam Etmiyor'
  | 'İptal';

export type TrialStatus = 'Planlandı' | 'Yapıldı' | 'Öğrenci Katılmadı' | 'Ertelendi' | 'İptal';
export type TrialResult = 'Aktif Derse Döndü' | 'Kararsız' | 'Devam Etmeyecek' | 'Tekrar Aranacak' | '-';
export type LessonStatus = 'Yapıldı' | 'Ertelendi' | 'İptal' | 'Öğrenci Katılmadı';
export type PaymentStatus = 'Dekont Bekleniyor' | 'Dekont Geldi' | 'Yönetici Kontrolünde' | 'Onaylandı' | 'Eksik Ödeme' | 'İptal';
export type GroupStatus = 'Talep Toplama' | 'Açıldı' | 'Devam Ediyor' | 'Tamamlandı' | 'İptal';

// ===================== BRANCHES =====================

export const BRANCHES = [
  'Türkçe', 'Matematik', 'Fen Bilimleri', 'Sosyal Bilgiler', 'İnkılap',
  'Edebiyat', 'Fizik', 'Kimya', 'Biyoloji', 'İngilizce', 'Arapça',
  'İlkokul Tüm Dersler', 'LGS Hazırlık', 'YKS Hazırlık'
];

export const GRADE_LEVELS = [
  '1. Sınıf', '2. Sınıf', '3. Sınıf', '4. Sınıf',
  '5. Sınıf', '6. Sınıf', '7. Sınıf', '8. Sınıf (LGS)',
  '9. Sınıf', '10. Sınıf', '11. Sınıf', '12. Sınıf (YKS)'
];

// ===================== TEACHERS =====================

export interface Teacher {
  id: string;
  name: string;
  phone: string;
  email: string;
  branches: string[];
  gradeLevels: string[];
  canOnline: boolean;
  canFaceToFace: boolean;
  availability: string;
  defaultRate: number;
  commissionRate: number;
  activeStudents: number;
  lessonsThisMonth: number;
  earningsThisMonth: number;
  pendingEarnings: number;
  status: 'Aktif' | 'Pasif';
  joinDate: string;
  note: string;
}

export const teachers: Teacher[] = [
  {
    id: 't1', name: 'Ahmet Yıldız', phone: '0532 111 2233', email: 'ahmet.yildiz@dersegel.com',
    branches: ['Matematik', 'Fizik', 'YKS Hazırlık'], gradeLevels: ['9. Sınıf', '10. Sınıf', '11. Sınıf', '12. Sınıf (YKS)'],
    canOnline: true, canFaceToFace: true, availability: 'Haftaiçi 14:00-22:00, Haftasonu 10:00-20:00',
    defaultRate: 400, commissionRate: 50, activeStudents: 12, lessonsThisMonth: 38, earningsThisMonth: 7600,
    pendingEarnings: 2400, status: 'Aktif', joinDate: '2024-01-15', note: 'Deneyimli YKS matematik hocası.'
  },
  {
    id: 't2', name: 'Selin Kaya', phone: '0533 222 3344', email: 'selin.kaya@dersegel.com',
    branches: ['Türkçe', 'Edebiyat', 'LGS Hazırlık'], gradeLevels: ['7. Sınıf', '8. Sınıf (LGS)', '9. Sınıf', '10. Sınıf'],
    canOnline: true, canFaceToFace: false, availability: 'Haftaiçi 13:00-21:00',
    defaultRate: 350, commissionRate: 50, activeStudents: 9, lessonsThisMonth: 28, earningsThisMonth: 4900,
    pendingEarnings: 1750, status: 'Aktif', joinDate: '2024-03-10', note: 'Online derslerde çok başarılı.'
  },
  {
    id: 't3', name: 'Mehmet Demir', phone: '0534 333 4455', email: 'mehmet.demir@dersegel.com',
    branches: ['Fen Bilimleri', 'Kimya', 'Biyoloji'], gradeLevels: ['6. Sınıf', '7. Sınıf', '8. Sınıf (LGS)', '11. Sınıf'],
    canOnline: true, canFaceToFace: true, availability: 'Haftaiçi 15:00-22:00',
    defaultRate: 380, commissionRate: 50, activeStudents: 7, lessonsThisMonth: 22, earningsThisMonth: 4180,
    pendingEarnings: 1140, status: 'Aktif', joinDate: '2024-02-20', note: 'LGS Fen konularında uzman.'
  },
  {
    id: 't4', name: 'Ayşe Şahin', phone: '0535 444 5566', email: 'ayse.sahin@dersegel.com',
    branches: ['İngilizce'], gradeLevels: ['5. Sınıf', '6. Sınıf', '7. Sınıf', '8. Sınıf (LGS)', '9. Sınıf', '10. Sınıf'],
    canOnline: true, canFaceToFace: true, availability: 'Her gün 09:00-21:00',
    defaultRate: 360, commissionRate: 50, activeStudents: 11, lessonsThisMonth: 35, earningsThisMonth: 6300,
    pendingEarnings: 900, status: 'Aktif', joinDate: '2023-11-05', note: 'IELTS sertifikalı, konuşma odaklı.'
  },
  {
    id: 't5', name: 'Emre Çelik', phone: '0536 555 6677', email: 'emre.celik@dersegel.com',
    branches: ['Matematik', 'LGS Hazırlık', 'İlkokul Tüm Dersler'], gradeLevels: ['4. Sınıf', '5. Sınıf', '6. Sınıf', '7. Sınıf', '8. Sınıf (LGS)'],
    canOnline: true, canFaceToFace: false, availability: 'Haftaiçi 16:00-22:00, Cumartesi 10:00-18:00',
    defaultRate: 320, commissionRate: 50, activeStudents: 6, lessonsThisMonth: 18, earningsThisMonth: 2880,
    pendingEarnings: 640, status: 'Aktif', joinDate: '2024-05-01', note: 'İlkokul ve ortaokul odaklı.'
  },
  {
    id: 't6', name: 'Fatma Arslan', phone: '0537 666 7788', email: 'fatma.arslan@dersegel.com',
    branches: ['Sosyal Bilgiler', 'İnkılap', 'Edebiyat'], gradeLevels: ['5. Sınıf', '6. Sınıf', '7. Sınıf', '8. Sınıf (LGS)'],
    canOnline: false, canFaceToFace: true, availability: 'Haftaiçi 14:00-20:00',
    defaultRate: 300, commissionRate: 50, activeStudents: 4, lessonsThisMonth: 12, earningsThisMonth: 1800,
    pendingEarnings: 300, status: 'Pasif', joinDate: '2024-04-12', note: 'Şu an izinli.'
  }
];

// ===================== STUDENTS =====================

export interface Student {
  id: string;
  name: string;
  parentName: string;
  phone: string;
  city: string;
  grade: string;
  branches: string[];
  lessonType: 'Birebir Online' | 'Yüz Yüze' | 'Grup Dersi' | 'KPSS';
  assignedTeacherId: string | null;
  status: 'Aktif' | 'Pasif' | 'Takipte';
  totalLessons: number;
  totalPayment: number;
  lastLessonDate: string;
  registrationDate: string;
  notes: string;
}

export const students: Student[] = [
  { id: 's1', name: 'Zeynep Kılıç', parentName: 'Hasan Kılıç', phone: '0532 100 2200', city: 'Antalya', grade: '8. Sınıf (LGS)', branches: ['Matematik', 'Fen Bilimleri'], lessonType: 'Birebir Online', assignedTeacherId: 't1', status: 'Aktif', totalLessons: 24, totalPayment: 9600, lastLessonDate: '2026-05-15', registrationDate: '2026-01-10', notes: 'LGS\'e hazırlanıyor.' },
  { id: 's2', name: 'Ali Öztürk', parentName: 'Veli Öztürk', phone: '0533 200 3300', city: 'Antalya', grade: '11. Sınıf', branches: ['Fizik', 'Matematik'], lessonType: 'Birebir Online', assignedTeacherId: 't1', status: 'Aktif', totalLessons: 18, totalPayment: 7200, lastLessonDate: '2026-05-14', registrationDate: '2026-02-05', notes: 'YKS Sayısal odaklı.' },
  { id: 's3', name: 'Elif Arslan', parentName: 'Murat Arslan', phone: '0534 300 4400', city: 'Antalya', grade: '7. Sınıf', branches: ['Türkçe', 'Sosyal Bilgiler'], lessonType: 'Birebir Online', assignedTeacherId: 't2', status: 'Aktif', totalLessons: 15, totalPayment: 5250, lastLessonDate: '2026-05-13', registrationDate: '2026-02-20', notes: '' },
  { id: 's4', name: 'Can Şahin', parentName: 'Ayhan Şahin', phone: '0535 400 5500', city: 'İstanbul', grade: '10. Sınıf', branches: ['İngilizce'], lessonType: 'Birebir Online', assignedTeacherId: 't4', status: 'Aktif', totalLessons: 20, totalPayment: 7200, lastLessonDate: '2026-05-15', registrationDate: '2026-01-25', notes: 'IELTS hedefi var.' },
  { id: 's5', name: 'Sude Yılmaz', parentName: 'Kemal Yılmaz', phone: '0536 500 6600', city: 'Antalya', grade: '5. Sınıf', branches: ['İlkokul Tüm Dersler'], lessonType: 'Birebir Online', assignedTeacherId: 't5', status: 'Aktif', totalLessons: 12, totalPayment: 3840, lastLessonDate: '2026-05-12', registrationDate: '2026-03-01', notes: 'Genel tekrar.' },
  { id: 's6', name: 'Berk Demir', parentName: 'Serkan Demir', phone: '0537 600 7700', city: 'Antalya', grade: '9. Sınıf', branches: ['Kimya', 'Biyoloji'], lessonType: 'Yüz Yüze', assignedTeacherId: 't3', status: 'Aktif', totalLessons: 10, totalPayment: 3800, lastLessonDate: '2026-05-11', registrationDate: '2026-03-15', notes: '' },
  { id: 's7', name: 'Mira Güneş', parentName: 'Tolga Güneş', phone: '0538 700 8800', city: 'Ankara', grade: '12. Sınıf (YKS)', branches: ['YKS Hazırlık', 'Matematik'], lessonType: 'Birebir Online', assignedTeacherId: 't1', status: 'Takipte', totalLessons: 6, totalPayment: 2400, lastLessonDate: '2026-04-28', registrationDate: '2026-04-10', notes: 'Velisi kararlı değil.' },
  { id: 's8', name: 'Arda Koç', parentName: 'Bülent Koç', phone: '0539 800 9900', city: 'Antalya', grade: '6. Sınıf', branches: ['Matematik'], lessonType: 'Birebir Online', assignedTeacherId: null, status: 'Pasif', totalLessons: 0, totalPayment: 0, lastLessonDate: '-', registrationDate: '2026-05-01', notes: 'Öğretmen bekleniyor.' },
];

// ===================== APPLICATIONS =====================

export interface Application {
  id: string;
  date: string;
  studentName: string;
  parentName: string;
  phone: string;
  city: string;
  grade: string;
  branch: string;
  lessonType: 'Birebir Online' | 'Yüz Yüze' | 'Grup Dersi' | 'KPSS';
  source: 'Instagram' | 'WhatsApp' | 'Tavsiye' | 'Manuel' | 'Reklam';
  status: ApplicationStatus;
  target: string;
  notes: string;
}

export const applications: Application[] = [
  { id: 'a1', date: '2026-05-16', studentName: 'Kerem Aydın', parentName: 'Nihat Aydın', phone: '0532 901 1122', city: 'Antalya', grade: '8. Sınıf (LGS)', branch: 'Matematik', lessonType: 'Birebir Online', source: 'Instagram', status: 'Yeni Başvuru', target: 'LGS', notes: 'Acil başlamak istiyor.' },
  { id: 'a2', date: '2026-05-15', studentName: 'Lara Çetin', parentName: 'Hülya Çetin', phone: '0533 902 2233', city: 'Antalya', grade: '11. Sınıf', branch: 'Fizik', lessonType: 'Birebir Online', source: 'WhatsApp', status: 'Öğretmen Aranıyor', target: 'YKS', notes: '' },
  { id: 'a3', date: '2026-05-14', studentName: 'Yusuf Polat', parentName: 'Gülay Polat', phone: '0534 903 3344', city: 'İzmir', grade: '9. Sınıf', branch: 'İngilizce', lessonType: 'Birebir Online', source: 'Reklam', status: 'Öğretmene Yönlendirildi', target: 'Okula destek', notes: '' },
  { id: 'a4', date: '2026-05-13', studentName: 'Nisa Aktaş', parentName: 'Orhan Aktaş', phone: '0535 904 4455', city: 'Antalya', grade: '7. Sınıf', branch: 'Türkçe', lessonType: 'Birebir Online', source: 'Tavsiye', status: 'Deneme Dersi Planlandı', target: 'Okula destek', notes: 'Tavsiye eden: Elif Arslan velisi' },
  { id: 'a5', date: '2026-05-12', studentName: 'Ege Kara', parentName: 'Selma Kara', phone: '0536 905 5566', city: 'Antalya', grade: '12. Sınıf (YKS)', branch: 'YKS Hazırlık', lessonType: 'Birebir Online', source: 'Instagram', status: 'Deneme Dersi Yapıldı', target: 'YKS', notes: '' },
  { id: 'a6', date: '2026-05-10', studentName: 'Derin Yıldız', parentName: 'Canan Yıldız', phone: '0537 906 6677', city: 'Antalya', grade: '6. Sınıf', branch: 'Fen Bilimleri', lessonType: 'Birebir Online', source: 'WhatsApp', status: 'Aktif Derse Başladı', target: 'Eksik kapatma', notes: '' },
  { id: 'a7', date: '2026-05-08', studentName: 'Tuna Bulut', parentName: 'Ferhat Bulut', phone: '0538 907 7788', city: 'Ankara', grade: '10. Sınıf', branch: 'Kimya', lessonType: 'Birebir Online', source: 'Reklam', status: 'Takipte', target: 'Okula destek', notes: '' },
  { id: 'a8', date: '2026-05-05', studentName: 'İrem Özer', parentName: 'Levent Özer', phone: '0539 908 8899', city: 'Antalya', grade: '5. Sınıf', branch: 'İlkokul Tüm Dersler', lessonType: 'Birebir Online', source: 'Manuel', status: 'İptal', target: 'Genel destek', notes: 'Aile şehir dışı çıktı.' },
];

// ===================== TRIAL LESSONS =====================

export interface TrialLesson {
  id: string;
  date: string;
  time: string;
  studentId: string;
  studentName: string;
  parentName: string;
  phone: string;
  branch: string;
  teacherId: string;
  teacherName: string;
  plannedDuration: '20 dk' | '40 dk' | 'Diğer';
  actualDuration: string;
  status: TrialStatus;
  result: TrialResult;
  studentAttended: boolean;
  parentSatisfied: boolean;
  studentWantsContinue: boolean;
  recommendedWeeklyLessons: number;
  teacherNote: string;
  adminNote: string;
}

export const trialLessons: TrialLesson[] = [
  { id: 'tr1', date: '2026-05-16', time: '14:00', studentId: 's8', studentName: 'Arda Koç', parentName: 'Bülent Koç', phone: '0539 800 9900', branch: 'Matematik', teacherId: 't5', teacherName: 'Emre Çelik', plannedDuration: '40 dk', actualDuration: '40 dk', status: 'Planlandı', result: '-', studentAttended: false, parentSatisfied: false, studentWantsContinue: false, recommendedWeeklyLessons: 0, teacherNote: '', adminNote: '' },
  { id: 'tr2', date: '2026-05-15', time: '15:30', studentId: 's7', studentName: 'Mira Güneş', parentName: 'Tolga Güneş', phone: '0538 700 8800', branch: 'YKS Hazırlık', teacherId: 't1', teacherName: 'Ahmet Yıldız', plannedDuration: '40 dk', actualDuration: '45 dk', status: 'Yapıldı', result: 'Kararsız', studentAttended: true, parentSatisfied: true, studentWantsContinue: false, recommendedWeeklyLessons: 2, teacherNote: 'Seviye iyi ama motivasyon eksik.', adminNote: 'Veli aranacak.' },
  { id: 'tr3', date: '2026-05-14', time: '16:00', studentId: 's1', studentName: 'Zeynep Kılıç', parentName: 'Hasan Kılıç', phone: '0532 100 2200', branch: 'Matematik', teacherId: 't1', teacherName: 'Ahmet Yıldız', plannedDuration: '40 dk', actualDuration: '40 dk', status: 'Yapıldı', result: 'Aktif Derse Döndü', studentAttended: true, parentSatisfied: true, studentWantsContinue: true, recommendedWeeklyLessons: 3, teacherNote: 'Çok istekli, hızlı kavrar.', adminNote: '' },
  { id: 'tr4', date: '2026-05-12', time: '10:00', studentId: 's5', studentName: 'Sude Yılmaz', parentName: 'Kemal Yılmaz', phone: '0536 500 6600', branch: 'İlkokul Tüm Dersler', teacherId: 't5', teacherName: 'Emre Çelik', plannedDuration: '20 dk', actualDuration: '-', status: 'Öğrenci Katılmadı', result: 'Tekrar Aranacak', studentAttended: false, parentSatisfied: false, studentWantsContinue: false, recommendedWeeklyLessons: 0, teacherNote: '', adminNote: 'Veli bilgilendirildi.' },
  { id: 'tr5', date: '2026-05-10', time: '17:00', studentId: 's3', studentName: 'Elif Arslan', parentName: 'Murat Arslan', phone: '0534 300 4400', branch: 'Türkçe', teacherId: 't2', teacherName: 'Selin Kaya', plannedDuration: '40 dk', actualDuration: '40 dk', status: 'Yapıldı', result: 'Aktif Derse Döndü', studentAttended: true, parentSatisfied: true, studentWantsContinue: true, recommendedWeeklyLessons: 2, teacherNote: 'Anlama düzeyi iyi.', adminNote: '' },
];

// ===================== ACTIVE LESSONS =====================

export interface ActiveLesson {
  id: string;
  date: string;
  time: string;
  studentId: string;
  studentName: string;
  teacherId: string;
  teacherName: string;
  branch: string;
  duration: string;
  topic: string;
  homeworkGiven: boolean;
  homeworkDesc: string;
  quizDone: boolean;
  quizResult: string;
  performanceNote: string;
  repeatTopic: string;
  parentInformed: boolean;
  status: LessonStatus;
  paymentStatus: 'Ödendi' | 'Bekliyor' | 'Eksik';
  note: string;
}

export const activeLessons: ActiveLesson[] = [
  { id: 'l1', date: '2026-05-15', time: '15:00', studentId: 's1', studentName: 'Zeynep Kılıç', teacherId: 't1', teacherName: 'Ahmet Yıldız', branch: 'Matematik', duration: '60 dk', topic: 'Denklemler ve Eşitsizlikler', homeworkGiven: true, homeworkDesc: 'Sf. 45-48 alıştırmalar', quizDone: true, quizResult: '8/10', performanceNote: 'Çok iyi performans', repeatTopic: '', parentInformed: true, status: 'Yapıldı', paymentStatus: 'Ödendi', note: '' },
  { id: 'l2', date: '2026-05-15', time: '17:00', studentId: 's2', studentName: 'Ali Öztürk', teacherId: 't1', teacherName: 'Ahmet Yıldız', branch: 'Fizik', duration: '60 dk', topic: 'Kuvvet ve Hareket', homeworkGiven: true, homeworkDesc: 'Problem seti 5', quizDone: false, quizResult: '', performanceNote: 'Orta seviye', repeatTopic: 'İvme konusu tekrar edilecek', parentInformed: false, status: 'Yapıldı', paymentStatus: 'Ödendi', note: '' },
  { id: 'l3', date: '2026-05-14', time: '14:00', studentId: 's3', studentName: 'Elif Arslan', teacherId: 't2', teacherName: 'Selin Kaya', branch: 'Türkçe', duration: '50 dk', topic: 'Paragraf Yorumlama', homeworkGiven: true, homeworkDesc: 'Okunan: Öykü analizi', quizDone: true, quizResult: '7/10', performanceNote: 'İyi', repeatTopic: '', parentInformed: true, status: 'Yapıldı', paymentStatus: 'Bekliyor', note: '' },
  { id: 'l4', date: '2026-05-14', time: '16:00', studentId: 's4', studentName: 'Can Şahin', teacherId: 't4', teacherName: 'Ayşe Şahin', branch: 'İngilizce', duration: '60 dk', topic: 'Speaking: Daily Routines', homeworkGiven: false, homeworkDesc: '', quizDone: false, quizResult: '', performanceNote: 'Konuşma akıcılığı gelişiyor', repeatTopic: '', parentInformed: false, status: 'Yapıldı', paymentStatus: 'Ödendi', note: '' },
  { id: 'l5', date: '2026-05-13', time: '10:00', studentId: 's5', studentName: 'Sude Yılmaz', teacherId: 't5', teacherName: 'Emre Çelik', branch: 'İlkokul Tüm Dersler', duration: '45 dk', topic: 'Kesirler', homeworkGiven: true, homeworkDesc: 'Sf 32-34', quizDone: false, quizResult: '', performanceNote: 'Dikkati dağılıyor', repeatTopic: 'Paydaları eşitleme tekrar', parentInformed: true, status: 'Yapıldı', paymentStatus: 'Bekliyor', note: '' },
  { id: 'l6', date: '2026-05-12', time: '11:00', studentId: 's6', studentName: 'Berk Demir', teacherId: 't3', teacherName: 'Mehmet Demir', branch: 'Kimya', duration: '60 dk', topic: 'Asit-Baz Dengesi', homeworkGiven: true, homeworkDesc: 'Soru bankası bölüm 7', quizDone: true, quizResult: '9/10', performanceNote: 'Mükemmel', repeatTopic: '', parentInformed: false, status: 'Yapıldı', paymentStatus: 'Ödendi', note: '' },
  { id: 'l7', date: '2026-05-16', time: '09:00', studentId: 's2', studentName: 'Ali Öztürk', teacherId: 't1', teacherName: 'Ahmet Yıldız', branch: 'Matematik', duration: '60 dk', topic: 'Türev ve İntegral', homeworkGiven: false, homeworkDesc: '', quizDone: false, quizResult: '', performanceNote: '', repeatTopic: '', parentInformed: false, status: 'Yapıldı', paymentStatus: 'Bekliyor', note: '' },
];

// ===================== PAYMENTS / RECEIPTS =====================

export interface Payment {
  id: string;
  date: string;
  studentId: string;
  studentName: string;
  teacherId: string;
  teacherName: string;
  amount: number;
  lessonCount: number;
  status: PaymentStatus;
  adminApproved: boolean;
  teacherShare: number;
  platformShare: number;
  description: string;
  receiptImage: string | null;
}

export const payments: Payment[] = [
  { id: 'p1', date: '2026-05-10', studentId: 's1', studentName: 'Zeynep Kılıç', teacherId: 't1', teacherName: 'Ahmet Yıldız', amount: 1600, lessonCount: 4, status: 'Onaylandı', adminApproved: true, teacherShare: 800, platformShare: 800, description: 'Mayıs 1. dönem', receiptImage: null },
  { id: 'p2', date: '2026-05-12', studentId: 's2', studentName: 'Ali Öztürk', teacherId: 't1', teacherName: 'Ahmet Yıldız', amount: 1600, lessonCount: 4, status: 'Yönetici Kontrolünde', adminApproved: false, teacherShare: 800, platformShare: 800, description: 'Mayıs dersleri', receiptImage: 'dekont_p2.jpg' },
  { id: 'p3', date: '2026-05-14', studentId: 's3', studentName: 'Elif Arslan', teacherId: 't2', teacherName: 'Selin Kaya', amount: 1050, lessonCount: 3, status: 'Dekont Geldi', adminApproved: false, teacherShare: 525, platformShare: 525, description: '', receiptImage: 'dekont_p3.jpg' },
  { id: 'p4', date: '2026-05-15', studentId: 's4', studentName: 'Can Şahin', teacherId: 't4', teacherName: 'Ayşe Şahin', amount: 1440, lessonCount: 4, status: 'Onaylandı', adminApproved: true, teacherShare: 720, platformShare: 720, description: 'İngilizce mayıs', receiptImage: null },
  { id: 'p5', date: '2026-05-13', studentId: 's5', studentName: 'Sude Yılmaz', teacherId: 't5', teacherName: 'Emre Çelik', amount: 960, lessonCount: 3, status: 'Dekont Bekleniyor', adminApproved: false, teacherShare: 480, platformShare: 480, description: '', receiptImage: null },
  { id: 'p6', date: '2026-05-11', studentId: 's6', studentName: 'Berk Demir', teacherId: 't3', teacherName: 'Mehmet Demir', amount: 1520, lessonCount: 4, status: 'Onaylandı', adminApproved: true, teacherShare: 760, platformShare: 760, description: 'Kimya + Biyoloji', receiptImage: null },
  { id: 'p7', date: '2026-05-09', studentId: 's7', studentName: 'Mira Güneş', teacherId: 't1', teacherName: 'Ahmet Yıldız', amount: 800, lessonCount: 2, status: 'Eksik Ödeme', adminApproved: false, teacherShare: 400, platformShare: 400, description: 'Eksik ödeme bildirdi', receiptImage: null },
];

// ===================== GROUP LESSONS =====================

export interface GroupLesson {
  id: string;
  name: string;
  branch: string;
  level: string;
  teacherId: string;
  teacherName: string;
  maxCapacity: number;
  enrolledCount: number;
  price: number;
  days: string[];
  time: string;
  startDate: string;
  status: GroupStatus;
  description: string;
  enrolledStudents: string[];
}

export const groupLessons: GroupLesson[] = [
  { id: 'g1', name: 'LGS Matematik Grubu A', branch: 'Matematik', level: 'LGS', teacherId: 't1', teacherName: 'Ahmet Yıldız', maxCapacity: 6, enrolledCount: 5, price: 800, days: ['Salı', 'Perşembe'], time: '16:00', startDate: '2026-04-01', status: 'Devam Ediyor', description: 'LGS\'e yönelik yoğun matematik grubu.', enrolledStudents: ['Zeynep Kılıç', 'Ali Öztürk', 'Kerem Aydın', 'Lara Çetin', 'Ege Kara'] },
  { id: 'g2', name: 'LGS Fen Grubu B', branch: 'Fen Bilimleri', level: 'LGS', teacherId: 't3', teacherName: 'Mehmet Demir', maxCapacity: 8, enrolledCount: 3, price: 750, days: ['Pazartesi', 'Çarşamba'], time: '15:00', startDate: '2026-05-15', status: 'Açıldı', description: 'LGS Fen Bilimleri hazırlık grubu.', enrolledStudents: ['Berk Demir', 'Elif Arslan', 'Derin Yıldız'] },
  { id: 'g3', name: 'İngilizce Konuşma Grubu', branch: 'İngilizce', level: 'Ortaokul', teacherId: 't4', teacherName: 'Ayşe Şahin', maxCapacity: 5, enrolledCount: 0, price: 600, days: ['Cumartesi'], time: '10:00', startDate: '2026-06-01', status: 'Talep Toplama', description: 'Konuşma odaklı İngilizce grubu.', enrolledStudents: [] },
  { id: 'g4', name: 'YKS Matematik Yoğun', branch: 'YKS Hazırlık', level: 'YKS', teacherId: 't1', teacherName: 'Ahmet Yıldız', maxCapacity: 4, enrolledCount: 4, price: 1200, days: ['Pazartesi', 'Çarşamba', 'Cuma'], time: '18:00', startDate: '2026-03-01', status: 'Devam Ediyor', description: 'YKS Matematik yoğun hazırlık.', enrolledStudents: ['Ali Öztürk', 'Mira Güneş', 'Tuna Bulut', 'Yusuf Polat'] },
];

// ===================== COMMISSIONS =====================

export interface Commission {
  teacherId: string;
  teacherName: string;
  totalCollection: number;
  commissionRate: number;
  teacherEarning: number;
  paidAmount: number;
  pendingAmount: number;
  lastPaymentDate: string;
  status: 'Güncel' | 'Bekliyor' | 'Gecikmiş';
}

export const commissions: Commission[] = [
  { teacherId: 't1', teacherName: 'Ahmet Yıldız', totalCollection: 15200, commissionRate: 50, teacherEarning: 7600, paidAmount: 5200, pendingAmount: 2400, lastPaymentDate: '2026-05-01', status: 'Bekliyor' },
  { teacherId: 't2', teacherName: 'Selin Kaya', totalCollection: 9800, commissionRate: 50, teacherEarning: 4900, paidAmount: 3150, pendingAmount: 1750, lastPaymentDate: '2026-05-05', status: 'Bekliyor' },
  { teacherId: 't3', teacherName: 'Mehmet Demir', totalCollection: 8360, commissionRate: 50, teacherEarning: 4180, paidAmount: 3040, pendingAmount: 1140, lastPaymentDate: '2026-05-03', status: 'Bekliyor' },
  { teacherId: 't4', teacherName: 'Ayşe Şahin', totalCollection: 12600, commissionRate: 50, teacherEarning: 6300, paidAmount: 5400, pendingAmount: 900, lastPaymentDate: '2026-05-08', status: 'Güncel' },
  { teacherId: 't5', teacherName: 'Emre Çelik', totalCollection: 5760, commissionRate: 50, teacherEarning: 2880, paidAmount: 2240, pendingAmount: 640, lastPaymentDate: '2026-04-28', status: 'Bekliyor' },
  { teacherId: 't6', teacherName: 'Fatma Arslan', totalCollection: 3600, commissionRate: 50, teacherEarning: 1800, paidAmount: 1500, pendingAmount: 300, lastPaymentDate: '2026-04-15', status: 'Gecikmiş' },
];

// ===================== LESSON NOTES =====================

export interface LessonNote {
  id: string;
  studentId: string;
  teacherId: string;
  teacherName: string;
  lessonId: string;
  date: string;
  branch: string;
  note: string;
  type: 'Olumlu' | 'Olumsuz' | 'Nötr';
}

export const lessonNotes: LessonNote[] = [
  { id: 'n1', studentId: 's1', teacherId: 't1', teacherName: 'Ahmet Yıldız', lessonId: 'l1', date: '2026-05-15', branch: 'Matematik', note: 'Denklemler konusunda çok iyi ilerleme kaydetti. Ödevini eksiksiz yaptı.', type: 'Olumlu' },
  { id: 'n2', studentId: 's2', teacherId: 't1', teacherName: 'Ahmet Yıldız', lessonId: 'l2', date: '2026-05-15', branch: 'Fizik', note: 'İvme konusunu anlamakta zorlandı. Tekrar gerekiyor.', type: 'Olumsuz' },
  { id: 'n3', studentId: 's3', teacherId: 't2', teacherName: 'Selin Kaya', lessonId: 'l3', date: '2026-05-14', branch: 'Türkçe', note: 'Paragraf yorumlamada gelişme var. Sınav sonucu iyi.', type: 'Olumlu' },
  { id: 'n4', studentId: 's5', teacherId: 't5', teacherName: 'Emre Çelik', lessonId: 'l5', date: '2026-05-13', branch: 'İlkokul Tüm Dersler', note: 'Dikkati dağıldı, ödevi yapmamış. Veli bilgilendirildi.', type: 'Olumsuz' },
  { id: 'n5', studentId: 's6', teacherId: 't3', teacherName: 'Mehmet Demir', lessonId: 'l6', date: '2026-05-12', branch: 'Kimya', note: 'Asit-Baz konusunda mükemmel performans. Sınav 9/10.', type: 'Olumlu' },
];

// ===================== SETTINGS =====================

export const settings = {
  platformName: 'Dersegel Antalya',
  defaultCommissionRate: 50,
  defaultTrialDuration: '40 dk',
  branches: [...BRANCHES],
  gradeLevels: [...GRADE_LEVELS],
  lessonStatuses: ['Yapıldı', 'Ertelendi', 'İptal', 'Öğrenci Katılmadı'],
  paymentStatuses: ['Dekont Bekleniyor', 'Dekont Geldi', 'Yönetici Kontrolünde', 'Onaylandı', 'Eksik Ödeme', 'İptal'],
  applicationStatuses: ['Yeni Başvuru', 'Öğretmen Aranıyor', 'Öğretmene Yönlendirildi', 'Deneme Dersi Planlandı', 'Deneme Dersi Yapıldı', 'Aktif Derse Başladı', 'Takipte', 'Devam Etmiyor', 'İptal'],
};

// ===================== DASHBOARD STATS =====================

export const dashboardStats = {
  todayTrials: 3,
  todayActiveLessons: 7,
  weeklyLessons: 38,
  monthlyRevenue: 52400,
  monthlyTeacherCommission: 26200,
  pendingReceipts: 5,
  trialConversions: 12,
  activeTeachers: 5,
};

export const monthlyApplicationData = [
  { month: 'Oca', başvuru: 18 }, { month: 'Şub', başvuru: 24 }, { month: 'Mar', başvuru: 31 },
  { month: 'Nis', başvuru: 27 }, { month: 'May', başvuru: 42 }, { month: 'Haz', başvuru: 0 },
];

export const branchDemandData = [
  { name: 'Matematik', value: 35 }, { name: 'İngilizce', value: 20 }, { name: 'LGS Hazırlık', value: 15 },
  { name: 'Fen Bilimleri', value: 12 }, { name: 'YKS Hazırlık', value: 10 }, { name: 'Diğer', value: 8 },
];

export const monthlyRevenueData = [
  { month: 'Oca', gelir: 38000, 'hakediş': 19000 },
  { month: 'Şub', gelir: 43000, 'hakediş': 21500 },
  { month: 'Mar', gelir: 47000, 'hakediş': 23500 },
  { month: 'Nis', gelir: 50000, 'hakediş': 25000 },
  { month: 'May', gelir: 52400, 'hakediş': 26200 },
];